
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"7","height":"11","viewBox":"0 0 7 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.232 11c-.317 0-.621-.116-.864-.336a1.127 1.127 0 010-1.643L4.055 5.5l-3.7-3.519a1.127 1.127 0 010-1.644 1.272 1.272 0 011.729 0L6.647 4.68c.231.22.353.51.353.822 0 .313-.134.602-.353.822l-4.551 4.341c-.244.22-.56.336-.864.336z","fill":"currentColor"}})])
          )
        }
      }
    